import "./accordion/accordion.js";

import "./posts_loader/posts_loader.js";
import "./tab_content/tab_content.js";
import "./newsletter_signup/newsletter_signup.js";
import "./sliders/sliders.js";
import "./text_content/text_content.js";
import "./video/video.js";
import "./text_image_hero/text_image_hero.js";
import "./testimonial/testimonial.js";
import "./featured_plan/featured_plan.js";
import "./transitions/transitions.js";
import "./technical_info/technical_info.js";
import "./single_blog/single_blog.js";

import "./test_popup/test_popup.js";